import { Type } from 'class-transformer';

import { IPagination } from './utils';

export class ICityIndexTotal {
  id: string | number;
  @Type(() => Number)
  adet: number;
  @Type(() => Number)
  desi: number;
  @Type(() => Number)
  type: number;
  @Type(() => Boolean)
  hidden: boolean;
  @Type(() => Date)
  createdate: Date;
  @Type(() => Date)
  lastupdate: Date;
}

export class ICityIndexTotalListResponse extends IPagination {
  @Type(() => ICityIndexTotal)
  results: ICityIndexTotal[];
}
